module.exports = __webpack_public_path__ + "static/media/044-latvia.3237ad91.svg";